import { Instagram, Youtube, BookOpen } from "lucide-react";
import { scrollToId } from "@/lib/site";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-ink border-t border-bone/10 py-20"
    >
      <div className="mx-auto max-w-[1500px] px-6 sm:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-12">
          <div>
            <p className="font-serif uppercase tracking-[0.18em] text-bone text-4xl sm:text-6xl leading-none">
              Ride Like a Lady
            </p>
            <p className="mt-4 font-sans text-[0.7rem] uppercase tracking-[0.4em] text-bone-muted">
              Grace Edwards
            </p>
          </div>

          <nav className="flex flex-col gap-3">
            {[
              { label: "Books", id: "books" },
              { label: "About", id: "about" },
              { label: "Trailer", id: "trailer" },
            ].map((l) => (
              <button
                key={l.id}
                onClick={() => scrollToId(l.id)}
                data-testid={`footer-nav-${l.id}`}
                className="text-left font-sans text-xs uppercase tracking-[0.3em] text-bone-soft hover:text-bone transition-colors"
              >
                {l.label}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-5">
            {[
              { Icon: Instagram, label: "Instagram" },
              { Icon: Youtube, label: "YouTube" },
              { Icon: BookOpen, label: "Amazon" },
            ].map(({ Icon, label }) => (
              <a
                key={label}
                href="#"
                onClick={(e) => e.preventDefault()}
                aria-label={`${label} (link coming soon)`}
                title="Coming soon"
                data-testid={`footer-social-${label.toLowerCase()}`}
                className="flex h-11 w-11 items-center justify-center border border-bone/20 text-bone-muted hover:text-bone hover:border-bone/60 transition-colors cursor-pointer"
              >
                <Icon className="h-4 w-4" strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-bone/10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="font-sans text-[0.65rem] uppercase tracking-[0.3em] text-bone-muted">
            © {new Date().getFullYear()} Grace Edwards
          </p>
          <p className="font-serif italic text-sm text-bone-muted/70">
            This was never about the motorcycle.
          </p>
        </div>
      </div>
    </footer>
  );
};
